import { render, staticRenderFns } from "./CreateUpdateDistributor.vue?vue&type=template&id=5ee65cef&scoped=true&"
import script from "./CreateUpdateDistributor.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee65cef",
  null
  
)

export default component.exports